const STATUSES = {
  created: {
    name: "Criada",
    icon: "mdi-check",
    color: "blue",
    description: "A notificação foi criada"
  },
  scheduled: {
    name: "Agendada",
    icon: "mdi-clock-outline",
    color: "secondary",
    description: "A notificação foi agendada"
  },
  sent: {
    name: "Enviada",
    icon: "mdi-send",
    color: "green",
    description: "A notificação foi enviada"
  },
  failed: {
    name: "Falhou",
    icon: "mdi-cancel",
    color: "accent",
    description: "A notificação não foi enviada"
  },
  queued: {
    name: "Na fila",
    icon: "mdi-progress-upload",
    color: "#1A237E",
    description: "A notificação está na fila para ser enviada"
  }
};

export default {
  methods: {
    getStatus(status) {
      return STATUSES[status];
    }
  },
  filters: {
    getNotificationStatus(status, field) {
      return STATUSES[status] ? STATUSES[status][field] : "";
    },

    formatMessage(message) {
      if (message.length > 40) {
        return message.substring(0, 40) + "...";
      } else {
        return message;
      }
    },
    formatTitle(title) {
      if (title.length > 25) {
        return title.substring(0, 25) + "...";
      } else {
        return title;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/notificationMixin.js